import { createBehavior } from '@area17/a17-behaviors';

const inview = createBehavior(
  'inview',
  {
    createObserver(element, cb) {
      let observer;
      let options = {
        root: null,
        rootMargin: '0px',
        threshold: [this.options.threshold],
      };
      observer = new IntersectionObserver(cb, options);
      observer.observe(element);
      return observer;
    },
    createIntersectionObserver() {
      this.observer = this.createObserver(this.$node, (entries) => {
        for (let entry of entries) {
          if (entry.intersectionRatio > 0) {
            this.$node.classList.add('inview:is-visible');
            this.$node.dispatchEvent(new CustomEvent('inview:is-visible', {}));
          }
        }
      });
    },
  },
  {
    init() {
      this.options.threshold = this.options.threshold
        ? parseInt(this.options.threshold, 10)
        : 0;
      this.createIntersectionObserver();
    },
    destroy() {
      this.observer.unobserve(this.$node);
    },
  }
);

export default inview;
